import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { TaskResultComponent } from './task-result.component';
import { TaskSModule } from 'app/feature/monitor/task-s/task-s.module';

@NgModule({
    declarations: [TaskResultComponent],
    exports: [TaskResultComponent],
    imports: [
        CommonModule,
        TaskSModule,
    ],
})
export class TaskResultModule { }
